export default __webpack_public_path__ + "static/media/music-room.974d5963.jpg";